import { useStaticQuery, graphql } from "gatsby"

export const usePerformancesImages = () => {
  const data = useStaticQuery(graphql`
    query {
      _001_small: file(
        relativePath: { eq: "img/performances/Small001-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _002_small: file(
        relativePath: { eq: "img/performances/Small002-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _003_small: file(
        relativePath: { eq: "img/performances/Small003-min.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
